import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const PaymentLogServices = {

  create: async (data) => {
    console.log(data)
    if(data.paymentMethod != 1){
      delete data.bankId;
    }

    console.log(data)
    try{
    const response = await apiService.post(
      `/${slug}/supplier-payments/create`,
      data
    );
    return response.data;
  }catch(err){
    console.log(err)
    throw new Error(err)
  }
  },
  getList: async () => {
    try{
    const response = await apiService.get(`/${slug}/supplier-payments/getall`);
    return response.data;
    }catch(err){
      console.log(err)
      throw new Error(err)
    }
  },
  detail: async (id) => {
    try{
    const response = await apiService.get(`/${slug}/supplier-payments/get/${id}`);
    return response.data;
    }catch(err){
      console.log(err)
      throw new Error(err)
    }
  },
  update: async (id, data) => {
    try{
    const response = await apiService.put(
      `/${slug}/supplier-payments/update/${id}`,
      data
    );
    return response.data;
  }catch(err){
    console.log(err)
    throw new Error(err)
  }
  },
  delete: async (id) => {
    try{
    const response = await apiService.delete(
      `/${slug}/supplier-payments/delete/${id}`
    );
    return response.data;
  }catch(err){
    console.log(err)
    throw new Error(err)
  }
  },
};

export default PaymentLogServices;
